export enum BadgeAppearance {
    /**
     * @description badge light background color.
     */
    Label = 'label',

    /**
     * @description badge with outline border color.
     */
    Outline = 'outline',

    /**
     * @description badge with background color and clear text color.
     */
    Text = 'text'
}

/**
 * @description Union type for badge appearance that accepts both enum values and string literals
 * @example
 * ```typescript
 * const appearance: BadgeAppearance = 'label';
 * const appearance: BadgeAppearance = BadgeAppearance.Label;
 * ```
 */
export type BadgeAppearanceType  = 'label' | 'outline' | 'text';

/**
 * @description Union type for badge appearance that accepts both enum values and string literals
 * @example
 * ```typescript
 * const appearance: BadgeAppearance = 'label';
 * const appearance: BadgeAppearance = BadgeAppearance.Label;
 * ```
 */
export type IBadgeAppearance = BadgeAppearance | BadgeAppearanceType;
